export class Helper {
  public static Platforms = [
    'ios',
    'android',
    'uwp',
  ];

  public static PlatformNames: { [platform: string]: string } = {
    ios: 'iOS',
    android: 'Android',
    uwp: 'UWP',
  };

  public static PlatformIcons: { [platform: string]: string } = {
    ios: 'phone_iphone',
    android: 'android',
    uwp: 'desktop_windows',
  };

  public static BuildingRegex = `^[a-zA-Z][0-9a-zA-Z]*$`;

  public static ConvertDictToArray(dict: any): any[] {
    if (dict) {
      const keys = Object.keys(dict);
      return keys.map((key) => {
        const obj = dict[key];
        obj.id = key;
        return obj;
      });
    } else {
      return [];
    }
  }

  public static MapDict(dict: any, f: (d: any) => any): any {
    if (!dict || !f) {
      return {};
    }

    const newDict: any = {};
    Object.keys(dict).forEach((key) => {
      newDict[key] = f(dict[key]);
    });
    return newDict;
  }

  public static IsValidIdentifier(identifier: string): boolean {
    const eazyRegex = new RegExp(Helper.BuildingRegex);
    return eazyRegex.test(identifier);
  }
}
